<template>
	<div class="home">
		<template v-if="textMode && welcome_msg_status">
			<Welcome :path="path" />
		</template>
		<template v-else>
			<Queue :nums="data" :call_type="active"></Queue>
		</template>
	</div>
</template>

<script>
import { createWebsocket, dispose, post, removeItem } from "@/utils";
import { Queue, Welcome } from "@/components";
import config from '@/config';
export default {
	name: 'Home',
	components: { Queue, Welcome },
	data() {
		return {
			data: [],
			active: [],
			welcome_msg_status: false,
			textMode: false,
			path: '',
			timer: '',
			voiceEnable: false
		}
	},
	created() {
		this.getInitData()
		createWebsocket()
		/* 		this.timer = setTimeout(() => {
					if (this.checkCurrentNums == 0) {
						this.textMode = true;
					}
				}, 60000 * 3); */
		window.addEventListener('reset_calling', this.onReset)
		window.addEventListener('calling', this.onCall)
		window.addEventListener('strip_update', this.onConfigUpdate);
		window.addEventListener('voice_update', this.onVoiceUpdate);
	},
	methods: {
		onReset(data) {
			// 重置
			this.getInitData();
		},
		//websocket 設置聲音
		onVoiceUpdate({ data }) {
			const { strip_is_voice } = data.data;
			this.voiceEnable = parseInt(strip_is_voice) === 1;
		},
		onCall({ data }) {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.checkCurrentNums();
			}, 60000 * 3);//三秒内无叫号列表自动切换欢迎语
			const numberData = data.data;
			const sn = numberData.sn;
			const voice = data.voice;
			this.textMode = false
			if (voice?.length < 1) return;
			if (this.voiceEnable) {
				for (let i = 0; i < voice.length; i++) {
					let item = voice[i];
					if (Number(item.value) === -1) continue;
					window.bridge?.tts(sn, item.value, 0.8);
				}
			}
			const id = Number(data.data.id)
			const table_type_id = Number(data.data.table_type_id)
			let exist = this.data.some(i => i.id === Number(id));
			//如果没找到就push进去
			if (!exist) {
				//先删除该类型的数据
				const index = this.data.findIndex(item => item.table_type_id === table_type_id);
				//转成数字
				data.data.id = id;
				data.data.table_type_id = table_type_id;
				if (index > -1) {
					this.$set(this.data, index, data.data)
				} else {
					this.data.push(data.data);
				}
			}
			const index = this.active.indexOf(table_type_id)
			if (index < 0) this.active.push(table_type_id)
			setTimeout(() => {
				let index = this.active.indexOf(table_type_id)
				if (index > -1) this.active.splice(index, 1)
			}, 10000);

		},
		// 配置更新
		onConfigUpdate({ data }) {
			const { show_waiting_time, speed, force_logout, welcome_msg_status } = data.data
			this.speed = Number.parseInt(speed)
			this.showAwait = Number.parseInt(show_waiting_time) === 1;
			//this.textMode = welcome_msg_status === '1';
			this.welcome_msg_status = welcome_msg_status === '1';
			if (force_logout == '1') {
				removeItem(config.tokenName);
				dispose()
				window.location.reload();
			}
		},
		//查询叫号数据设置状态
		checkCurrentNums() {
			post('/get_number/get_number/current_queuing').then(res => {
				if (res.data == 0) this.textMode = true;
			}).catch(e => {
				alert(e);
			});
		},
		getInitData() {
			post('/get_number/strip/index').then(res => {
				this.data = res.data.list;
				this.showAwait = res.data['waiting_time_status']
				this.path = res.data['welcome_image']
				this.textMode = res.data['queuing_num'] === 0;//没有人排队显示广告图片
				this.welcome_msg_status = res.data['welcome_msg_status'];
				this.voiceEnable = res.data['strip_is_voice'];
				//if (res.data['welcome_msg_status']) this.text = res.data.text;
			}).catch(e => {
				//console.warn(e)
				if (e.status == 'expired') {
					location.reload();
				}

			})
		}
	},
	computed: {
		isTextMode() {
			return this.data.length < 1 || this.textMode
		},
		bgStyle() {
			return this.isTextMode ? 'background-color: var(--text-bg-color);' : ''
		}
	},
	beforeDestroy() {
		window.removeEventListener('calling', this.onCall)
		window.removeEventListener('reset_calling', this.onReset)
		window.removeEventListener('strip_update', this.onConfigUpdate);
		window.removeEventListener('voice_update', this.onVoiceUpdate);
		dispose()
	}
}
</script>

<style scoped>
.home {
	height: 100%;
	position: relative;
}
</style>
